<div class="row mt-3 mb-5 mx-3 mx-md-0">
  <div class="col-12 col-md-10 offset-md-1 justify-content-center">

    <mat-card class="rounded-0 border">
      <mat-card-title>
        <h2 class="color-blue-cat">Mis Proyectos</h2>
      </mat-card-title>      
      <mat-card-content>

        <!---Button Agregar nuevo proyecto-->            
        <div class="d-flex justify-content-end" *ngIf="dataSource.data.length < 10">
          <button mat-fab color="primary" matTooltip="Agregar proyecto" matTooltipPosition="left" (click)="openDialog()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <!---End Button Agregar nuevo proyecto-->

        <!---Alert a mostrar cuando el número de proyectos creados sean igual o mayores a 10-->
        <div class="alert alert-danger mb-5" role="alert" *ngIf="dataSource.data.length >= 10">
          Se ha deshabilitado el botón de <b>Crear Proyecto</b> porque haz alcanzado el límite permitido (10 proyectos) para crear un nuevo proyecto.  
          Intenta eliminar algún proyecto que ya se encuentran registrados para agregar nuevos proyectos.
        </div>

        <div class="row">
          <mat-form-field class="col-12 col-md-4 mt-n4">
            <mat-label>Filtrar</mat-label>
            <input matInput (keyup)="applyFilter($event)" #input>
          </mat-form-field>
        </div>
        
        <table mat-table [dataSource]="dataSource" class="w-100 table-hover table-responsive-md">

          <!--Columna Título-->
          <ng-container matColumnDef="titulo">
            <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Proyecto</th>
            <td mat-cell *matCellDef="let element"><span (click)="openDialog(element.idProyecto)" style="cursor: pointer">{{element.titulo}}</span></td>
          </ng-container>
        
          <!--Columna Arquitectos -->
          <ng-container matColumnDef="arquitectos">
            <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Arquitectos</th>
            <td mat-cell *matCellDef="let element">{{element.arquitectos}}</td>
          </ng-container>
        
          <!--Columna Año -->
          <!-----
          <ng-container matColumnDef="anio">
            <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Año</th>
            <td mat-cell *matCellDef="let element">{{element.anio}}</td>
          </ng-container>-->
        
          <!--Columna Opciones -->
          <ng-container matColumnDef="opciones">
            <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Opciones</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button color="primary" [routerLink]="['/proyectos/detalle-proyecto/', element.idProyecto]" matTooltipPosition="above" matTooltip="Ver detalles">
                <mat-icon>remove_red_eye</mat-icon>
              </button>

              <button mat-icon-button color="accent" matTooltipPosition="above" matTooltip="Editar" (click)="openDialog(element.idProyecto)">
                <mat-icon>create</mat-icon>
              </button>

              <!---<button mat-icon-button color="accent" matTooltipPosition="above" matTooltip="Subir fotografías" (click)="openDialogUploadPhotos(element.idProyecto)">
                <mat-icon>cloud_upload</mat-icon>
              </button>--->

              <button mat-icon-button color="warn" matTooltipPosition="above" matTooltip="Eliminar fotografías" (click)="openDialogDeletePhotos(element.idProyecto)">
                <mat-icon>image_not_supported</mat-icon>
              </button>

              <button mat-icon-button color="warn" matTooltipPosition="above" matTooltip="Eliminar proyecto" (click)="deleteProyecto(element.idProyecto)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>                        
          
        </table>

        <!--Div a mostrar cuando estén cargando los datos-->
        <div class="alert alert-light text-center" *ngIf="loading">
          <p class="d-flex justify-content-center">
            <mat-spinner></mat-spinner>
          </p>
        </div>

        <!---Div a mostrar cuando no encuentre coincidencias--->
        <div class="alert" role="alert" *ngIf="!loading && dataSource.filteredData.length === 0">
          No se han encontrado resultados para: {{input.value}}
        </div>

        <!--Div a mostrar cuando no haya datos-->
        <div class="alert alert-info text-center" *ngIf="!loading && dataSource.data.length === 0">
          <p class="d-flex justify-content-center"><mat-icon class="icon-material">info</mat-icon></p>
          <h4 class="alert-heading">No hay datos para mostrar</h4>
        </div>   

        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        
      </mat-card-content>
    </mat-card>

  </div>
</div>